/* eslint-disable no-undef */
import * as React from 'react'
import JsonViewer from '../common/json.viewer'
import { isEmpty } from 'lodash'
import Spinner from '../common/loader'
import * as styles from './resizable.viewer.styl'
import { CSSSelector } from '@src/utils/css.selector.helper'
import { Format, getContentByFormat } from './helpers'

export { Format }

const topHeaderHeight = 80

export interface Props {
  id?: string
  data: string
  format?: Format
  title?: string
  onCloseViewer?: () => void
  loading?: boolean
}

export const ResizableViewerCSSSelectors = {
  resizableViewerSelector: new CSSSelector('resizableViewer'),
  titleSelector: new CSSSelector('titleViewer'),
  resizerSelector: new CSSSelector('resizerViewer'),
  closeSelector: new CSSSelector('closeViewer'),
  contentSelector: new CSSSelector('contentViewer'),
  spinnerSelector: new CSSSelector('spinnerViewer')
}

const ResizableViewer = React.forwardRef(
  (
    {
      data,
      title,
      id,
      loading = false,
      format = Format.text,
      onCloseViewer
    }: Props,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const [top, setTop] = React.useState('50vh')

    function onDrag(e: MouseEvent) {
      if (e.clientY >= topHeaderHeight) {
        setTop(e.clientY - topHeaderHeight + 'px')
      }
    }

    function onMouseDown(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
      document.body.addEventListener('mousemove', onDrag)
      document.body.addEventListener('mouseup', onMouseUp)
      document.body.addEventListener('mouseleave', onMouseUp)
    }

    function onMouseUp(e: MouseEvent) {
      document.body.removeEventListener('mousemove', onDrag)
      document.body.removeEventListener('mouseup', onMouseUp)
      document.body.removeEventListener('mouseleave', onMouseUp)
    }

    function renderContext() {
      return <JsonViewer>{getContentByFormat(data, format)}</JsonViewer>
    }
    function onClose() {
      onCloseViewer()
    }

    return (
      <div
        ref={ref}
        id={id}
        role={ResizableViewerCSSSelectors.resizableViewerSelector.value}
        className={styles.content}
        style={{ top }}
      >
        <div className={styles.header}>
          <div className={styles.leftSection}>
            <div
              role={ResizableViewerCSSSelectors.titleSelector.value}
              className={styles.title}
            >
              {title || 'JSON Viewer'}
            </div>
          </div>
          <div
            role={ResizableViewerCSSSelectors.resizerSelector.value}
            className={styles.resizer}
            draggable={false}
            onMouseDown={onMouseDown}
          />
          <div
            role={ResizableViewerCSSSelectors.closeSelector.value}
            onClick={onClose}
            className={styles.close}
          >
            <i className="material-icons">close</i>
          </div>
        </div>
        <div
          role={ResizableViewerCSSSelectors.contentSelector.value}
          className={styles.json}
        >
          {!isEmpty(data) && renderContext()}
          <Spinner
            className={ResizableViewerCSSSelectors.spinnerSelector.value}
            loading={loading}
          />
        </div>
      </div>
    )
  }
)

export default React.memo(ResizableViewer)
